module.exports = __webpack_public_path__ + "img/kort-13.41cd8104.jpg";